import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MainLayout } from '../../layouts/main';
import styles from './errorPage.module.css';

const ErrorPage = () => {
    const { state } = useLocation();
    const code = state?.code || 500;
    const backendMessage = state?.backendMessage;
    const time = state?.time || new Date().toLocaleString('ru-RU');

    return (
        <MainLayout className="d-flex flex-column justify-content-between">
            <div className="container-custom text-center py-5">
                <h1 className="mb-4 text-red">ОШИБКА {code}</h1>
                <h2 className="mb-4 par2">Произошла внутренняя ошибка</h2>
                <p className="body capital mb-3">
                    Сделайте скрин экрана и отправьте в поддержку, чтобы мы могли это исправить.
                </p>

                <div className={styles.errorsBlock}>
                    {backendMessage && <p className="mb-3">{backendMessage}</p>}
                    {time && <p>Время получения ошибки: {time}</p>}
                </div>

                <div className="d-flex align-items-center justify-content-center mt-3">
                    <Link to="/" className="btn btn-red-filled px-4 py-2">
                        На главную
                    </Link>
                </div>
            </div>
        </MainLayout>
    );
};

export default ErrorPage;
